module.exports = __webpack_public_path__ + "static/media/guarantee-badge.8b7914cc.png";